import styled from 'styled-components';

import { getPurpurBorder } from '@telialt/common-theme/src/purpurSelectors';

export const StyledSectionImage = styled.img`
    width: 100%;
    height: auto;
    border-radius: ${getPurpurBorder('radiusLg')};
`;
